import { getUrlParams } from '@mentimeter/core-presence';
import type { Question } from '@mentimeter/http-clients';
import { getDeviceId } from '@mentimeter/visitor/visitor-data';
import type { UserT } from '@mentimeter/user';
import type {
  KeyParamCollection,
  PresenceUrlPatterns,
  PresenceUser,
} from './types';

export const getActivePresenters = (collaborators: PresenceUser[]) =>
  collaborators.filter((d) => d.status === 'active' && d.actor === 'presenter');

const verifyParameters = (
  obj: Record<string, any>,
  reference: Record<string, any>,
) => Object.keys(reference).every((k) => obj[k] === reference[k]);

export const getEditorPresenceArray = (
  config: KeyParamCollection,
  collaborators?: Record<string, PresenceUser> | null,
): string[] => {
  return collaborators
    ? Object.keys(collaborators).filter((i) => {
        const presenceUser = collaborators[i];
        if (!presenceUser) return false;

        return validatePresenceUserLocation(presenceUser, config);
      })
    : [];
};

export const getEditorPresenceUsers = (
  config: KeyParamCollection,
  presenceState?: Record<string, PresenceUser> | null,
): PresenceUser[] => {
  if (!presenceState) return [];

  return Object.values(presenceState).filter((presenceUser) =>
    validatePresenceUserLocation(presenceUser, config),
  );
};

function validatePresenceUserLocation(
  presenceUser: PresenceUser,
  config: KeyParamCollection,
) {
  const params = getUrlParams<PresenceUrlPatterns>(
    config.id,
    presenceUser.location ?? '',
  );

  return (
    Boolean(params) &&
    verifyParameters(params as Record<string, any>, config.params || {})
  );
}

export function getQuestionBySlidePublicKey(
  questions: Question[],
  slidePublicKey: string,
) {
  return questions.find((question) => question.public_key === slidePublicKey);
}

export const getEditorDefaultPresenceData = (user: UserT): PresenceUser => {
  return {
    device_id: getDeviceId(),
    last_seen: Date.now(),
    status: 'active',
    location: '/series',
    actor: 'viewer',
    user_id: user.id,
    name: user.name,
    email: user.email,
    profile_picture_url: user.profile_picture?.presets.preview.url ?? '',
  };
};
